export const name = 'googleMap' as const
